import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { gridToLatLon } from '../utils/grid';
import './QsoMap.css';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Leaflet varsayılan ikon sorunu için düzeltme
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const bandColors = {
  '160m': '#a6cee3',
  '80m': '#1f78b4',
  '60m': '#b2df8a',
  '40m': '#33a02c',
  '30m': '#fb9a99',
  '20m': '#e31a1c',
  '17m': '#fdbf6f',
  '15m': '#ff7f00',
  '12m': '#cab2d6',
  '10m': '#6a3d9a',
  '6m': '#ffff99',
  '2m': '#b15928',
  '70cm': '#888888',
};

const QsoMap = () => {
  const { t } = useTranslation();
  const [lines, setLines] = useState([]);
  
  // Senin Konumun (KM69 - Ankara civarı merkezi)
  const MY_GRID = 'KM69';
  const MY_COORDS = gridToLatLon(MY_GRID); // [39.5, 33.0]

  useEffect(() => {
    const fetchGrids = async () => {
      try {
        const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
        const apiUrl = isLocal ? `http://192.3.10.53:3001/api/adif-grids` : '/api/adif-grids';
        
        const response = await fetch(apiUrl);
        const gridsData = await response.json();

        const newLines = gridsData
          .map(item => ({ ...item, coords: gridToLatLon(item.grid) }))
          .filter(item => item.coords !== null)
          .map(item => ({
            from: MY_COORDS,
            to: item.coords,
            grid: item.grid,
            count: item.count,
            // Çizgi rengi için ilk bandı kullan, yoksa gri olsun
            color: bandColors[item.bands[0]] || 'grey'
          }));

        setLines(newLines);
      } catch (error) {
        console.error('Map data fetch error:', error);
      }
    };

    fetchGrids();
  }, []);

  return (
    <div className="page" style={{ height: '80vh', display: 'flex', flexDirection: 'column' }}>
      <Helmet>
        <title>{t('navbar.map')} - TA2GBO</title>
      </Helmet>
      <h2 style={{ marginBottom: '20px' }}>{t('map.title')}</h2>
      
      <MapContainer center={MY_COORDS} zoom={3} style={{ height: '100%', width: '100%', borderRadius: '12px' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={MY_COORDS} icon={redIcon}>
          <Popup>
            TA2GBO <br /> {MY_GRID}
          </Popup>
        </Marker>
        
        {lines.map((line, idx) => (
          <React.Fragment key={idx}>
            <Polyline positions={[line.from, line.to]} color={line.color} weight={1.5} opacity={0.7} />
            <Marker position={line.to} icon={new L.Icon.Default({ iconSize: [12, 20], iconAnchor: [6, 20] })}>
               <Popup>{line.grid}<br />{t('map.qsoCount', { count: Number(line.count) })}</Popup>
            </Marker>
          </React.Fragment>
        ))}

        <div className="map-legend">
          <h4>{t('map.legendTitle')}</h4>
          {Object.entries(bandColors).map(([band, color]) => (
            <div key={band} className="legend-item">
              <span className="legend-color" style={{ backgroundColor: color }}></span>
              <span className="legend-label">{band}</span>
            </div>
          ))}
        </div>
      </MapContainer>
    </div>
  );
};

export default QsoMap;